import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import StaysPage from './pages/StaysPage';
import PackageDetailPage from './pages/PackageDetailPage';
import BillejePage from './pages/BillejePage';
import GalleriPage from './pages/GalleriPage';
import BegivenhederPage from './pages/BegivenhederPage';

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/om-os" element={<AboutPage />} />
        <Route path="/ophold" element={<StaysPage />} />
        <Route path="/billeje" element={<BillejePage />} />
        <Route path="/galleri" element={<GalleriPage />} />
        <Route path="/begivenheder" element={<BegivenhederPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/pakker/:slug" element={<PackageDetailPage />} />
        {/* Fallback for other routes */}
        <Route path="*" element={<Home />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
